/**
 * @file
 * ARK theme behaviors.
 */
(function (Drupal) {

  'use strict';
  /**
   * Footer sitemap toggle behavior.
   */
  Drupal.behaviors.footerSitemapToggle = {
    attach: function (context, settings) {


      const menutoggle = context.querySelector('.menu-toggle');
      if (menutoggle) {
        menutoggle.addEventListener('click', (event) => {
          const isExpanded = menutoggle.getAttribute('aria-expanded') === 'true';
          menutoggle.setAttribute('aria-expanded', !isExpanded);
          const nav = menutoggle.closest('.site-navigation');
          if (nav) {
            nav.classList.toggle('is-open');
          }
        });
      }

      const toggle = document.getElementById('sitemap-toggle');
      const sitemap = document.getElementById('footer-sitemap');

      if (!toggle || !sitemap) {
        return;
      }

      // Only attach once
      if (toggle.dataset.processed) {
        return;
      }
      toggle.dataset.processed = 'true';

      let isOpen = false; // Start closed

      // Set initial state
      sitemap.style.height = '0';
      sitemap.style.overflow = 'hidden';
      sitemap.style.display = 'block'; // Keep display block for height animation

      toggle.addEventListener('click', function() {
        const currentLang = document.documentElement.lang || 'nl';

        if (isOpen) {
          // Close sitemap with smooth animation
          sitemap.style.height = sitemap.scrollHeight + 'px'; // Set explicit height first

          // Force reflow
          sitemap.offsetHeight;

          // Then animate to 0
          sitemap.style.height = '0';
          toggle.textContent = 'sitemap';
          isOpen = false;
        } else {
          // Open sitemap with smooth animation
          const fullHeight = sitemap.scrollHeight;
          sitemap.style.height = fullHeight + 'px';

          // Set text based on language
          if (currentLang === 'en') {
            toggle.textContent = 'close sitemap';
          } else {
            toggle.textContent = 'sluit sitemap';
          }

          // Scroll to footer after animation starts
          setTimeout(function() {
            const docHeight = document.documentElement.scrollHeight;
            const windowHeight = window.innerHeight;
            const scrollPos = docHeight - windowHeight;

            window.scrollTo({
              top: scrollPos,
              behavior: 'smooth'
            });
          }, 100);

          isOpen = true;
        }
      });
    }
  };

  /**
   * Search box placeholder behavior.
   */
  Drupal.behaviors.searchBoxPlaceholder = {
    attach: function (context, settings) {
      const searchInput = document.querySelector('#searchbox input');

      if (!searchInput) {
        return;
      }

      const currentLang = document.documentElement.lang || 'nl';

      if (currentLang === 'en') {
        searchInput.setAttribute('placeholder', 'What are you looking for?');
      } else {
        searchInput.setAttribute('placeholder', 'Waar ben je naar op zoek?');
      }
    }
  };

  // /**
  //  * Gallery overlay click behavior.
  //  */
  // Drupal.behaviors.galleryOverlayClick = {
  //   attach: function (context, settings) {
  //     const overlays = context.querySelectorAll('.gallery-overlay');
  //
  //     overlays.forEach(function(overlay) {
  //       if (overlay.dataset.processed) {
  //         return;
  //       }
  //       overlay.dataset.processed = 'true';
  //
  //       overlay.addEventListener('click', function(e) {
  //         e.preventDefault();
  //         const link = this.parentElement.querySelector('a:not(.gallery-overlay)');
  //         if (link) {
  //           link.click();
  //         }
  //       });
  //     });
  //   }
  // };


  Drupal.behaviors.menuToggles = {
    attach (context, settings) {
      const menutoggle = context.querySelector('.menu-toggle');
      if (menutoggle) {
        menutoggle.addEventListener('click', (event) => {
          console.log('Menu toggle clicked');
          const isExpanded = menutoggle.getAttribute('aria-expanded') === 'true';
          menutoggle.setAttribute('aria-expanded', !isExpanded);
          const nav = document.getElementById('block-wisenten-theme-main-menu');
          if (nav) {
            nav.classList.toggle('is-open');
          }
        });
      }

      const submenutoggles = context.querySelectorAll('.submenu-toggle');
      console.log('Found submenu toggles:', submenutoggles.length);
      submenutoggles.forEach(toggle => {
        toggle.addEventListener('click', (event) => {
          console.log('Submenu toggle clicked');
          const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', !isExpanded);
          const menuItem = toggle.closest('.menu-item');
          if (menuItem) {
            menuItem.classList.toggle('is-submenu-open');
            console.log('Toggled is-submenu-open on', menuItem);
          }
        });
      });
    }
  };

} (Drupal));
